import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { bindActionCreators } from 'redux';

import * as FPAIConstants from '../../constants';
import * as D from '../../deps';

import './FamilyVendorBilledError.scss';

export class FamilyVendorBilledError extends Component {
  static propTypes = {
    listenerEmail: PropTypes.string,
    vendor: PropTypes.string,
    tier: PropTypes.string,
    discountType: PropTypes.string,
    familyPlanInviteToken: PropTypes.string,
    signOut: PropTypes.func,
  };

  onSwitchAccountsClick = () => {
    const encodedFamilyPlanInviteToken = encodeURIComponent(this.props.familyPlanInviteToken);
    const postLogoutPath = `${D.Utils.Route.getFamilyPlanInviteeLandingPath()}?fpi=${encodedFamilyPlanInviteToken}`;
    this.props.signOut(postLogoutPath);
  };

  render() {
    const { listenerEmail, vendor, tier, discountType } = this.props;
    const planName = D.PaymentsUtils.getPlanName(tier, discountType);
    const isPremium = D.PaymentsUtils.isPremiumPlan(tier);
    const PREMIUM_FAMILY_HELP_URL = 'http://help.pandora.com/s/article/000002262';
    const LEARN_MORE_CANCEL_HELP_URL =
      'http://help.pandora.com/s/article/Cancel-your-Subscription-1519949295562';
    const premiumText = isPremium && (
      <FormattedMessage {...FPAIConstants.Messages.willBeWaitingWhenYouJoinFamily} />
    );
    return (
      <div className='FamilyVendorBilledError'>
        <h1 className='FamilyVendorBilledError__title'>
          <FormattedMessage {...FPAIConstants.Messages.unableToJoinFamilyPlan} />
        </h1>
        <h2 className='FamilyVendorBilledError__intro'>
          <FormattedMessage
            {...FPAIConstants.Messages.accountAlreadySubscribed}
            values={{ listenerEmail, vendor, planName }}
          />
        </h2>
        <div className='FamilyVendorBilledError__content'>
          <p className='FamilyVendorBilledError__stepsIntro'>
            <FormattedMessage {...FPAIConstants.Messages.toJoinThePremiumFamilyPlan} />
          </p>
          <div className='FamilyVendorBilledError__options'>
            <Link
              className='FamilyVendorBilledError__loginLink'
              onClick={this.onSwitchAccountsClick}
            >
              <FormattedMessage {...FPAIConstants.Messages.loginWithADifferentAccount} />
            </Link>
            <p className='FamilyVendorBilledError__or'>- OR -</p>
            <ol className='FamilyVendorBilledError__ol'>
              <li className='FamilyVendorBilledError__li'>
                <FormattedMessage
                  {...FPAIConstants.Messages.cancelYourExistingSubscription}
                  values={{ vendor }}
                />{' '}
                <Link
                  to={LEARN_MORE_CANCEL_HELP_URL}
                  target='_blank'
                  className='FamilyVendorBilledError__learnMore'
                >
                  <FormattedMessage {...FPAIConstants.Messages.learnMoreAboutCancelling} />
                </Link>
              </li>
              <li className='FamilyVendorBilledError__li'>
                <FormattedMessage {...FPAIConstants.Messages.waitForSubscriptionExpire} />{' '}
                {premiumText}
              </li>
              <li className='FamilyVendorBilledError__li'>
                <FormattedMessage {...FPAIConstants.Messages.reacceptYourInvite} />
              </li>
            </ol>
          </div>
        </div>
        <Link
          to={PREMIUM_FAMILY_HELP_URL}
          target='_blank'
          className='FamilyVendorBilledError__learnMore'
        >
          <FormattedMessage {...FPAIConstants.Messages.learnMoreAboutJoiningFamily} />
        </Link>
      </div>
    );
  }
}

export function mapStateToProps(state) {
  return {
    listenerEmail: D.Utils.Listener.getCurrentUsername(state),
    vendor: D.PaymentsSelectors.getDisplayablePaymentProvider(state),
    tier: D.PaymentsSelectors.getActiveProductGroupTier(state),
    discountType: D.PaymentsSelectors.getActiveProductDiscountType(state),
  };
}

export function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      signOut: D.Actions.UseCases.signOut,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(FamilyVendorBilledError);
